import { useState } from "react"

import { ExpandMore } from "@mui/icons-material"
import { Avatar, Card, Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material"

import { strings } from "../../config/strings"

interface UserCard { username: string, userRole:string, onLogoutClick?:() => void }

export const UserCard = (props: UserCard) => {

    const [anchorEl, setAnchorEl] = useState<Element|undefined>(undefined)

    const stringAvatar = (name: string) => {

        return name.split(' ').map( item => {
            return item[0].toUpperCase()
        })
    }
      
    const handleDiscloseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(undefined)
    }

    return (
        <Card sx={{m:2, p:2}}>
            <Grid container spacing={2} alignItems='center'>
                <Grid size={2}>
                    <Avatar sx={{bgcolor:'secondary.main'}}>{stringAvatar(props.username)}</Avatar>
                </Grid>
                <Grid size={8}>
                    <Typography variant='h6'>{props.username}</Typography>
                    <Typography variant='subtitle2' color={'text.secondary'}>{props.userRole}</Typography>
                </Grid>
                <Grid size={2}>
                    <IconButton onClick={handleDiscloseClick}>
                        <ExpandMore/>
                    </IconButton>
                </Grid>
            </Grid>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <MenuItem 
                    onClick={props.onLogoutClick}>
                    {strings.logout}
                </MenuItem>
            </Menu>
        </Card>
    )
}